import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/cn';
import { badgeVariants } from './badge.variants';

export interface BadgeProps extends React.ComponentProps<'span'>, VariantProps<typeof badgeVariants> {
  /**
   * Plan tag ("BASIC", "BUSINESS"): small caps in the plan's own colours
   * (`--plan-*` in kit-next.css), never a status tone. `tone` is ignored.
   */
  plan?: BadgePlan;
  /**
   * 6px status dot before the text, in the text colour. The redesigned kit
   * already draws it on `success` / `warning`; this adds it to any tone (a
   * neutral "Borrador" next to a green "Publicado").
   */
  dot?: boolean;
}

export type BadgePlan = 'basic' | 'pro' | 'business' | 'enterprise';

export function Badge({ className, tone, plan, dot, ...props }: BadgeProps) {
  // `data-slot`/`data-tone` are stable hooks for the redesigned kit (kit-next.css).
  return (
    <span
      data-slot="badge"
      data-tone={tone ?? 'neutral'}
      data-plan={plan}
      data-dot={dot ? '' : undefined}
      className={cn(
        badgeVariants({ tone }),
        plan && 'uppercase tracking-wide',
        dot && "before:size-1.5 before:shrink-0 before:rounded-pill before:bg-current before:content-['']",
        className,
      )}
      {...props}
    />
  );
}
